<template>
  <Head title="どうぶつ看護ポータル" />
  <!-- ローディングアニメーション -->
  <div>
    <transition name="fade">
      <div
        v-show="isShowSplash"
        id="splash">
        <div id="splash_logo">
          <img
            width="500px"
            src="/images/zoo-logo.png"
            alt=""
            class="fadeUp">
        </div>
      </div>
    </transition>
  </div>

  <div class="md:flex relative">
    <header class="md:mt-8 md:ml-24 p-6 md:p-0">
      <div class="w-full md:w-72 md:pb-60">
        <a href="#">
          <img
            src="/images/zoo-logo.png"
            class="md:mr-8 w-52 md:w-72" />
        </a>
        <ul class="hidden md:block items-center">
          <li
            class="text-sm my-4 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
            <a
              href="#terakoya"
              class="block font-bold ml-7 letter-4">
              オンライン予備校(寺子屋)
              <span class="block text-xs text-gray-500 mt-3 letter-3">
                国試対策Web映像授業<br />
                臨床セミナー
              </span>
            </a>
          </li>
          <li
            class="text-sm mt-4 mb-8 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
            <a
              href="#mobile"
              class="block font-bold ml-7 letter-4">
              どうぶつ看護ポータル
              <span class="block text-xs text-gray-500 mt-3 letter-3">
                国試対策問題演習アプリ
              </span>
            </a>
          </li>
          <li
            class="text-sm my-4 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
            <a
              href="#exam"
              class="block font-bold ml-7 letter-4">
              全国統一模試
              <span class="block text-xs text-gray-500 mt-3 letter-3">
                オンライン受験<br />
                オフライン受験(学校様向け)
              </span>
            </a>
          </li>
        </ul>
        <div class="hidden md:block justify-end sm:flex-none sm:justify-start">
          <div>
            <button
              class="block mb-4 w-full text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-5 rounded-bl-2xl hover:opacity-70 duration-300 letter-4"
              @click.prevent="isShowSignIn = true">
              ログイン
            </button>
            <button
              class="block w-full text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-5 rounded-bl-2xl hover:opacity-70 duration-300 letter-4"
              @click.prevent="isShowSignUp = true">
              無料会員登録
            </button>
          </div>
        </div>
      </div>

      <button
        :class="isOpen
          ? 'absolute z-30 lg:hidden h-5 w-6 top-7 right-3'
          : 'absolute z-30 md:hidden h-5 w-6 top-7 right-3'
        "
        @click="toggleBtn">
        <span
          :class="isOpen
            ? 'transform rotate-45 top-2 w-7 transition duration-300'
            : 'top-0 w-6'
          "
          class="h-0.5 rounded inline-block transition-all absolute right-0 bg-black"></span>
        <span
          :class="isOpen ? 'hidden' : 'top-2 w-6'"
          class="h-0.5 inline-block transition-all absolute right-0 bg-black"></span>
        <span
          :class="isOpen
            ? 'transform -rotate-45 top-2 w-7 transition duration-300'
            : 'top-4 w-6'
          "
          class="h-0.5 rounded inline-block transition-all absolute right-0 bg-black"></span>
      </button>

      <div
        :class="isOpen
          ? 'block bg-black w-full h-full top-0 left-0 opacity-80 cursor-pointer z-30'
          : 'hidden transition-all duration-500'
        "
        @click="toggleBtn"></div>

      <div class="text-left">
        <nav
          :class="isOpen ? '-right-0 opacity-100' : '-right-full opacity-0'"
          class="fixed z-20 bg-white top-0 button-0 text-current w-60 h-screen transition-all duration-300">
          <div class="pt-14 px-4">
            <ul class="items-center">
              <li
                class="text-sm my-4 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#terakoya"
                  class="block font-bold ml-4 letter-3">
                  オンライン予備校(寺子屋)
                  <span class="block text-xs text-gray-500 mt-3 ml-4 letter-3">
                    国試対策Web映像授業<br />
                    臨床セミナー
                  </span>
                </a>
              </li>
              <li
                class="text-sm mt-4 mb-8 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#mobile"
                  class="block font-bold ml-4 letter-3">
                  どうぶつ看護ポータル
                  <span class="block text-xs text-gray-500 mt-3 ml-4 letter-3">
                    国試対策問題演習アプリ
                  </span>
                </a>
              </li>
              <li class="text-sm my-4 py-4 border-l-4 border-gray-100 md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#exam"
                  class="block font-bold ml-4 letter-3">
                  全国統一模試
                  <span class="block text-xs text-gray-500 mt-3 ml-4 letter-3">
                    オンライン受験<br />
                    オフライン受験(学校様向け)
                  </span>
                </a>
              </li>
            </ul>
            <div class="justify-end sm:flex-none sm:justify-start">
              <div>
                <button
                  class="text-sm block mb-4 w-full text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-2 rounded-bl-2xl hover:opacity-70 duration-300 letter-4"
                  @click.prevent="isShowSignIn = true">
                  ログイン
                </button>
                <button
                  class="text-sm block w-full text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-2 rounded-bl-2xl hover:opacity-70 duration-300 letter-4"
                  @click.prevent="isShowSignUp = true">
                  無料会員登録
                </button>
              </div>
            </div>
          </div>
        </nav>
        <div
          :class="isOpen
            ? 'block bg-black w-full h-full top-0 left-0 fixed opacity-80 cursor-pointer z-10'
            : 'hidden transition-all duration-500'
          "
          @click="toggleBtn"></div>
      </div>
    </header>

    <sign-in-modal
      :is-show="isShowSignIn"
      @reset-password="onClickResetPassword"
      @close="isShowSignIn = false" />

    <reset-password-modal
      :is-show="isShowResetPassword"
      @close="isShowResetPassword = false" />

    <sign-up-modal
      :is-show="isShowSignUp"
      @close="isShowSignUp = false" />

    <div class="flex-1 ml-12">
      <img
        src="/images/vt-study_01.png"
        class="heroimage h-full object-cover opacity-80 md:opacity-50" />
    </div>
  </div>

  <div :style="{ opacity: opacitySection1 }">
    <div class="flex flex-col md:flex-row mt-24">
      <div class="flex-1 w-full md:w-1/2 order-1">
        <img
          v-show="isShowMission"
          src="/images/vt-study_02.png"
          class="w-full mission-image radius-right h-full opacity-75 object-cover" />
      </div>
      <div class="mt-32 md:mt-0 md:w-1/2 md:order-2">
        <section class="mission px-8">
          <div class="text-center">
            <transition name="slide">
              <div v-show="isShowMission">
                <h2 class="mission_title text-2xl font-bold mb-8">
                  <span class="spanColor">M</span>ISSION
                </h2>
                <span class="mission_subtitle block font-bold mb-8">ミッション</span>
              </div>
            </transition>
          </div>
          <div class="-translate-y-2 transition duration-500">
            <transition name="slide">
              <hr
                v-show="isShowMission"
                class="block pb-6 md:pb-16 border-0 border-t-2 border-black" />
            </transition>
            <transition name="slide">
              <h4
                v-show="isShowMission"
                class="font-bold mb-10 leading-6 md:leading-10 letter-4">
                <span class="spanColor">ど</span>うぶつの未来を担う次世代が<br />
                愛玩動物看護師という仕事に人生をかけられる<br />
                業界を創造する
              </h4>
            </transition>
            <transition name="slide">
              <p
                v-show="isShowMission"
                class=" text-sm md:text-base leading-6 md:leading-8 tracking-wider">
                どうぶつに安全と安心を届ける動物医療のため、<br />
                愛玩動物看護師はその中枢を担っていくでしょう。<br /><br />
                どうぶつ看護ポータルは、どうぶつと愛玩動物看護師に<br />
                誠実に寄り添い続けると共に、<br />
                どうぶつのために働く愛玩動物看護師が物心ともに豊かになるよう<br />
                業界の未来に挑戦していきます。<br /><br />
                小学生、中学生、高校生など、未来を担う若い世代が<br />
                胸を張って愛玩動物看護師を目指せる業界を<br />
                <span class="spanColor">どうぶつ看護ポータル</span>とともに。
              </p>
            </transition>
          </div>
        </section>
      </div>
    </div>

    <section class="service mt-32">
      <div class="text-center">
        <h2 class="mission_title text-2xl font-bold mb-8">
          <span class="spanColor">S</span>ERVICE
        </h2>
        <span class="mission_subtitle block font-bold">サービス</span>
      </div>

      <div
        id="terakoya"
        class="flex flex-col lg:flex-row items-center mt-12">
        <div class="w-full lg:w-1/2 order-1">
          <a
            href="https://www.rinshovet.blog/"
            target="_blank"
            rel="noopener noreferrer">
            <img
              src="/images/vt-study_04.png"
              class="w-full object-cover service-image radius-right relative" />
          </a>
        </div>
        <div class="my-12 lg:m-12 w-full lg:w-1/2 flex-1 px-8 lg:px-0 lg:order-2">
          <div class="lg:block flex justify-center">
            <a
              href="https://www.rinshovet.blog/"
              target="_blank"
              rel="noopener noreferrer"
              class="mx-auto inline-block hover-parent cursor-pointer">
              <div class="flex items-center justify-center">
                <div class="text-center lg:text-left text-lg font-bold letter-3">オンライン予備校(寺子屋)</div>
                <div
                  class="hover-child bg-gray-100 hover:bg-gray-300 cursor-pointer transition duration-500 ml-2 w-12 h-12 rounded-full flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                      d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
          <hr class="block boder-0 border-t-1" />
          <h4 class="text-center lg:text-left text-sm text-gray-500 lg:font-bold my-4 lg:mb-16 letter-3">
            <span class="inline-block mx-3">国試対策Web映像授業</span><span class="inline-block">臨床セミナー</span>
          </h4>
          <p class="leading-6 lg:leading-8 tracking-wider text-sm lg:text-base">
            愛玩動物看護師国家試験合格へ向けて頑張るすべての方を応援するサイトです。<br />
            オンライン予備校(寺子屋)は愛玩動物看護師国家試験合格を目指してみんなで勉強していく「インプット型」セミナーになります。<br />
            その他にもテーマごとのセミナーや参加型のフォーラムなど様々なコンテンツを展開しています。<br /><br />
            一部コンテンツは有料となりますのでログインもしくは会員登録していただき、ご購読お願いいたします。
          </p>
        </div>
      </div>

      <div
        id="mobile"
        class="lg:flex items-center mt-12">
        <div class="mx-auto my-12 lg:m-12 w-full lg:w-1/2 flex-1 px-8 lg:px-0">
          <div class="text-center lg:text-left text-lg font-bold mb-2 letter-3">どうぶつ看護ポータル</div>
          <hr class="block boder-0 border-t-1" />
          <h4 class="text-center lg:text-left text-sm text-gray-500 lg:font-bold my-4 lg:mb-16 letter-3">国試対策問題演習アプリ</h4>
          <p class="leading-6 lg:leading-8 tracking-wider text-sm lg:text-base">
            ・国家試験コアカリキュラムに準拠した愛玩動物看護師の演習問題を約1000問用意<br />
            ・科目、分野ごとにクイズ形式で学習可能<br />
            ・体験模試と連携し、模試に出てきた問題も復習可能<br />
            ・問題ごとの理解度設定や毎日の学習記録が付けられる<br />
            ・正答率の傾向などから苦手な分野を分析し重点的に学習可能<br />
          </p>
          <div class="flex items-center justify-center mt-16">
            <a
              href="https://play.google.com/store/apps/details?id=com.vet.animal_portal&hl=bs"
              target="_blank"
              rel="noopener noreferrer"
              class="linkbtn hover:-translate-y-1 transition duration-300">
              <img
                src="/images/google-play-badge.png"
                class="w-36 mx-auto" />
            </a>
            <a
              href="https://apps.apple.com/jp/app/%E3%81%A9%E3%81%86%E3%81%B6%E3%81%A4%E7%9C%8B%E8%AD%B7%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB/id1628987767"
              target="_blank"
              rel="noopener noreferrer"
              class="linkbtn hover:-translate-y-1 transition duration-300 ml-4">
              <img
                src="/images/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.svg"
                class="w-32 mx-auto" />
            </a>
          </div>
        </div>
        <div class="lg:ml-auto lg:w-1/2">
          <div class="w-full service-image radius-left bg-pink-50 relative">
            <img
              src="/images/appimage.webp"
              class="absolute left-0 right-0 m-auto portal-image" />
          </div>
        </div>
      </div>

      <div
        id="exam"
        class="lg:flex lg:items-center mt-12">
        <div class="mx-auto mb-12 lg:m-12 w-full lg:w-1/2 flex-1 px-8 lg:px-0">
          <div class="lg:block flex justify-center">
            <a
              class="inline-block hover-parent cursor-pointer"
              @click.prevent="isShowSignIn = true">
              <div class="flex items-center">
                <div class="text-center lg:text-left text-lg font-bold letter-3">全国統一模試</div>
                <div
                  class="hover-child bg-gray-100 hover:bg-gray-300 cursor-pointer transition duration-500 ml-2 w-12 h-12 rounded-full flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                      d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
          <hr class="block boder-0 border-t-1" />
          <h4 class="break-normal text-center lg:text-left text-sm text-gray-500 lg:font-bold my-4 lg:mb-16 letter-3">
            <span class="inline-block mx-3">オンライン受験</span><span class="inline-block">オフライン受験(学校様向け)</span>
          </h4>
          <p class="leading-6 lg:leading-8 tracking-wider text-sm lg:text-base">
            ・コア・カリキュラム準拠で獣医師が傾向と対策を完全分析<br />
            ・愛玩動物看護師国家試験本番と同様の形式と問題数<br />
            　必須問題50問、一般問題100問、実地問題50問で構成される本格的な模擬試験<br />
            ・オンライン模試なので忙しい動物看護師や学生でもいつでもどこでも受験が可能<br />
            ・さまざまな職種やキャリアの受験生の得意分野と苦手分野を結果とともにお知らせ<br />
            ・国家試験対策アプリ『どうぶつ看護ポータル』と連携して復習が可能<br />
          </p>
        </div>
        <div class="lg:w-1/2">
          <div>
            <a
              class="cursor-pointer"
              @click.prevent="isShowSignIn = true">
              <img
                src="/images/top-image.webp"
                class="w-full object-cover service-image radius-left" />
            </a>
          </div>
        </div>
      </div>

      <div class="text-center mt-32">
        <p class="md:text-xl font-bold md:leading-10 letter-4 mb-8">
          サービスを始めるには、ログインまたは新規会員登録が必要です。<br>一緒に始めましょう。
        </p>
        <div class="md:flex md:justify-center md:space-x-4">
          <button
            class="block mx-auto md:mx-0 mb-4 md:mb-0 w-72 text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-3 md:py-5 rounded-bl-2xl hover:opacity-70 duration-300 text-sm md:text-base letter-4"
            @click.prevent="isShowSignIn = true">
            ログイン
          </button>
          <button
            class="block mx-auto md:mx-0 w-72 text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-3 md:py-5 rounded-bl-2xl hover:opacity-70 duration-300 text-sm md:text-base letter-4"
            @click.prevent="isShowSignUp = true">
            無料会員登録
          </button>
        </div>
      </div>
    </section>

    <div class="bgRightPink mt-32">
      <section class="news py-12">
        <div class="md:flex justify-between">
          <div class="text-center w-full md:w-4/12 mb-12 md:mb-0">
            <h2 class="mission_title text-2xl font-bold mb-4 md:mb-8">
              <span class="spanColor">N</span>EWS
            </h2>
            <span class="mission_subtitle block font-bold">お知らせ</span>
          </div>
          <ul class="w-11/12 mx-auto md:w-full md:pr-52">
            <li
              v-for="(information, i) in informationList"
              :key="i"
              class=""
              @click.prevent="onClickInformation(information.id)">
              <button class="text-left">
                <span class="text-gray-500 text-sm mb-4 leading-8 letter-3">{{
                  moment(`${information.created_at}`).format("YYYY.MM.DD")
                }}</span>
                <p class="letter-3">{{ information.subject }}</p>
              </button>
            </li>
          </ul>
        </div>
        <div class="text-center text-base">
          <button
            class="block w-72 mx-auto text-white text-center font-bold bg-CLIENT_PRIMARY_PINK shadow py-3 md:py-5 rounded-bl-2xl hover:opacity-70 duration-300 mt-16 text-sm md:text-base letter-4"
            @click.prevent="onClickInformationList">
            もっと見る
          </button>
        </div>
      </section>

      <section class="bunner py-10 mx-auto w-11/12 md:w-full">
        <div class="md:flex justify-center py-10 md:gap-x-3">
          <a
            class="block mb-4"
            target="_blank"
            rel="noopener noreferrer"
            href="https://and-vet.com/">
            <img
              class="mx-auto w-52 md:w-80 md:mr-5 shadow"
              src="/images/andvet-hp.png" />
          </a>
          <a
            class="block mb-4"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.qnote.co.jp/">
            <img
              class="mx-auto w-52 md:w-80 md:ml-5 shadow"
              src="/images/qnote-hp.png" />
          </a>
        </div>
      </section>

      <div class="flex">
        <footer class="bg-white md:w-full py-20 px-2 md:px-12 radius-right">
          <div class="flex justify-center">
            <a href="#">
              <img
                src="/images/zoo-logo.png"
                class="mx-auto md:mx-0 md:mr-8 w-44 md:w-72 h-auto object-contain" />
            </a>
          </div>
          <div class="md:flex justify-center">
            <ul class="md:flex items-start">
              <li
                class="mx-4 mt-10 text-sm text-center md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#terakoya"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="block font-bold letter-4">オンライン予備校(寺子屋)<span
                    class="block text-xs text-gray-400 mt-3 letter-3">国試対策Web映像授業</span><span
                    class="block text-xs text-gray-400 mt-3 letter-3">臨床セミナー</span></a>
              </li>
              <li
                class="mx-4 mt-10 text-sm text-center md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#mobile"
                  class="block font-bold letter-4">どうぶつ看護ポータル<span
                    class="block text-xs text-gray-400 mt-3 letter-3">国試対策問題演習アプリ</span></a>
              </li>
              <li
                class="mx-4 mt-10 text-sm text-center md:text-base hover:-translate-y-1 transition duration-300">
                <a
                  href="#exam"
                  class="block font-bold letter-4">全国統一模試<span
                    class="block text-xs text-gray-400 mt-3 letter-3">オンライン受験</span><span
                    class="block text-xs text-gray-400 mt-3 letter-3">オフライン受験(学校様向け)</span></a>
              </li>
            </ul>
          </div>

          <div class="text-xs flex md:justify-center mt-20 md:mt-36 flex-wrap">
            <a
              class="block md:ml-8 w-1/2 md:w-auto text-gray-400 hover:text-black"
              :href="route('portal.guide.company')">運営会社について</a>
            <a
              class="block md:ml-8 w-1/2 md:w-auto text-gray-400 hover:text-black"
              :href="route('portal.guide.terms')">利用規約</a>
            <a
              class="block md:ml-8 w-1/2 md:w-auto text-gray-400 hover:text-black mt-4 md:mt-0"
              :href="route('portal.guide.privacy')">プライバシーポリシー</a>
            <a
              class="block md:ml-8 w-1/2 md:w-auto text-gray-400 hover:text-black mt-4 md:mt-0"
              :href="route('portal.guide.asct')">特定商取引法に基づく表記</a>
          </div>
        </footer>
        <div class="w-16 md:w-48 flex justify-center items-end mb-20 md:mb-36">
          <a
            href="#"
            class="text-gray-400 verticalRL letter-3">Page Top</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment'
import { ref, computed, onMounted } from 'vue'
import 'firebase/compat/auth'
import { Inertia } from '@inertiajs/inertia'
import 'vue3-carousel/dist/carousel.css'
import Swal from 'sweetalert2'
import { Head } from '@inertiajs/inertia-vue3'
import SignInModal from '@/Pages/Client/Partials/SignInModal'
import ResetPasswordModal from '@/Pages/Client/Partials/ResetPasswordModal'
import SignUpModal from '@/Pages/Client/Partials/SignUpModal'

const isOpen = ref(false)

const props = defineProps({
  informationList: {
    type: Array,
    default: () => [],
  },
})

const isShowSignIn = ref(false)
const isShowSignUp = ref(false)
const isShowResetPassword = ref(false)

const onClickInformationList = () => {
  Inertia.get(route('portal.information.index'))
}

const onClickInformation = (information) => {
  Inertia.get(
    route('portal.information.show', {
      information,
    }),
  )
}

const onClickResetPassword = () => {
  isShowSignIn.value = false
  isShowResetPassword.value = true
}

const scrollControl = () => {
  if (isOpen.value) {
    document.documentElement.style.overflow = 'hidden'
  } else {
    document.documentElement.style.overflow = 'auto'
  }
}

const toggleBtn = () => {
  isOpen.value = !isOpen.value
  scrollControl()
}

function scroll_control(event) {
  event.preventDefault()
}

onMounted(() => {
  document.addEventListener('mousewheel', scroll_control, {
    passive: false,
  })
  document.addEventListener('touchmove', scroll_control, {
    passive: false,
  })

  window.addEventListener('scroll', handleScroll)
  setTimeout(() => {
    isShowSplash.value = false
    document.removeEventListener('mousewheel', scroll_control, {
      passive: false,
    })
    document.removeEventListener('touchmove', scroll_control, {
      passive: false,
    })
  }, 2000)
})

const opacitySection0 = ref(1)
const opacitySection1 = ref(0)
const isShowSplash = ref(true)
const isShowMission = ref(false)
const maxScrollY = ref(0)

const resetFlag = () => {
  isShowMission.value = false
}

const handleScroll = () => {
  if (scrollY == 0) {
    resetFlag()
  }

  if (scrollY > 100) {
    let y = scrollY
    if (y > 500) {
      y = 500
    }
    opacitySection0.value = 1 - (y - 100) / 500

    y = scrollY
    if (y > 600) {
      y = 600
    }
    opacitySection1.value = (y - 100) / 500
  }

  if (maxScrollY.value < scrollY) {
    maxScrollY.value = scrollY
  }

  if (scrollY > 200) {
    isShowMission.value = true
  }
}
</script>

<style>
/* 汎用 */
.radius-right {
  border-top-right-radius: 100px;
}

.radius-left {
  border-top-left-radius: 100px;
}

.spanColor {
  color: #ef8886;
}

.letter-4 {
  letter-spacing: 4px;
}

.letter-3 {
  letter-spacing: 3.2px;
}

.bgRightPink {
  background-color: #fcfafa;
}

.verticalRL {
  writing-mode: vertical-rl;
}

/* ここから各部CSS */
.catchcopy {
  font-size: 70px;
  padding-right: 100px;
  padding-bottom: 20px;
  border-bottom: solid 4px #000;
  letter-spacing: 42px;
}

.heroimage {
  border-bottom-left-radius: 200px;
}

.mission_title {
  font-size: 42px;
  letter-spacing: 8.4px;
}

.service-image {
  height: 500px;
}

.service-image .portal-image {
  height: 100%;
}

.portal-image {
  height: calc(100% + 100px);
}

.service hr {
  width: calc(100% + 98px);
  border-color: #ef8886;
}

.news ul li button {
  border-top: solid 1px #bfbfbf;
  padding: 40px 20px;
  width: 100%;
  position: relative;
}

.news ul li:last-child button {
  border-bottom: solid 1px #bfbfbf;
}

.news ul li button::before {
  content: "";
  position: absolute;
  width: 0;
  left: 0;
  bottom: -2px;
  border-bottom: solid 2px #ff8a80;
  transition: 0.3s;
}

.news ul li button:hover::before {
  width: 100%;
}

.hover-parent:hover .hover-child {
  background-color: #d1d5db;

}

/* ここからレスポンシブ */
@media screen and (max-width: 767px) {
  .heroimage {
    width: 100%;
    height: 60vh;
    border-bottom-left-radius: 50px;
  }

  .catchcopy {
    font-size: 20px;
    letter-spacing: 8px;
    padding: 20px;
  }

  .mission {
    background-position: center;
  }

  .mission_text {
    background: rgba(255, 255, 255, 0.7);
    padding: 50px 0;
  }

  .service__box {
    display: block;
    margin: 100px 0;
  }

  .service__box::after {
    content: none;
  }

  .service hr {
    width: auto;
  }

  .service-image {
    height: 300px;
  }

  .service-image img {
    object-fit: contain;
    max-height: 500px;
  }

  .news ul li button {
    padding: 20px;
  }

  footer {
    width: 90%;
  }

}

/* ローディングアニメーション */
/* Loading背景画面設定　*/
#splash {
  /*fixedで全面に固定*/
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #fff;
  text-align: center;
  /* color:#fff; */
}

/* Loading画像中央配置　*/
#splash_logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Loading アイコンの大きさ設定　*/
#splash_logo img {
  width: 500px;
}

/* fadeUpをするアイコンの動き */
.fadeUp {
  animation-name: fadeUpAnime;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}

@keyframes fadeUpAnime {
  from {
    opacity: 0;
    transform: translateY(100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/*========= レイアウトのためのCSS ===============*/

#container {
  width: 100%;
  height: 100vh;
  background: #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

a {
  color: #333;
}

a:hover {
  text-decoration: none;
}

/* ローディングアニメーション */
.slide-enter-from {
  transform: translateY(50px);
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: all 0.3s ease-out;
}

.slide-leave-to {
  transform: translateY(50px);
  opacity: 0;
}

/* 表示時の状態 */
.fade-enter-from {
  opacity: 0;
}

/* 表示時の終了状態 */
.fade-enter-to {
  opacity: 1;
}

/* 非表示時の状態 */
.fade-leave-from {
  opacity: 1;
}

/* 非表示時のアクティブ状態 */
.fade-leave-active {
  transition: opacity 300ms ease-out;
}

/* 非表示時の終了状態 */
.fade-leave-to {
  opacity: 0;
}</style>
